import React, { useContext } from 'react';
import './job-image.scss';
import Job from '../types/job';
import { StateContext } from '../../state/contexts';

export type Properties = {
  job: Job;
  withImage?: boolean;
};

const JobImage = ({ job, withImage = false }: Properties) => {
  const state = useContext(StateContext);
  const { config } = state;
  const { lazyLoading } = config.config.ui;

  return (
    <>
      {withImage && job.images?.find((image) => image.type === 'JOB_PUBLICATION_PAGE_PANORAMA') && (
        <img
          className="card-img-top"
          alt={job.position}
          src={job.images?.find((image) => image.type === 'JOB_PUBLICATION_PAGE_PANORAMA')?.url}
          loading={lazyLoading ? 'lazy' : 'eager'}
        />
      )}
    </>
  );
};

export default JobImage;
